import React from 'react';
import { Tabs as MuiTbas } from '@material-ui/core';
import styled from 'styled-components/macro';

const Tabs = styled(MuiTbas)`
  && {
    background: #fff;
    ${({ disableBottomBorder }) =>
      disableBottomBorder ? '' : 'border-bottom: 1px solid lightgrey;'}
  }
  button {
    text-transform: capitalize;
    padding-left: 2em;
    padding-right: 2em;
  }
  [class*='Mui-selected'] {
    color: #4c84ff;
    font-weight: 600;
  }
`;

const TabsView = props => {
  return (
    <Tabs
      indicatorColor="primary"
      TabIndicatorProps={{ style: { height: 3 } }}
      {...props}
    />
  );
};

export default TabsView;
